type RuntimeConfig = {
    apiUrl?: string;
};

const runtimeConfig: RuntimeConfig =
    (globalThis as unknown as { config?: RuntimeConfig }).config || {};

const idConstants = {
    globalLocationId: 1,
    USALocationId: 102,
    highMiddleSdiLocationId: 44634,
    highSdiLocationId: 44635,
    lowMiddleSdiLocationId: 44636,
    lowSdiLocationId: 44637,
    middleSdiLocationId: 44639,

    noSdiLocationIds: '!44639,44637,44636,44635,44634',

    maleAndFemaleGenderId: '1,2',
    maleGenderId: 1,
    femaleGenderId: 2,
    bothGendersId: 3,

    allAgesGroupId: 22,

    numberMetricId: 1,
    rateMetricId: 3,

    deathMeasureId: 1,
    dalyMeasureId: 2,
    yllMeasureId: 4,
    prevalenceMeasureId: 5,
    incidenceMeasureId: 6,

    tuberculosisCauseId: 297,
    hivAidsCauseId: 298,
    malariaCauseId: 345,
    acuteHepatitisCauseId: 400,
    acuteHepatitisBCauseId: 402,
    acuteHepatitisCCauseId: 403,
    liverCancerDueToHepBCauseId: 418,
    liverCancerDueToHepCCauseId: 419,
    cirrhosisAndLiverDiseasesDueToHepBCauseId: 522,
    cirrhosisAndLiverDiseasesDueToHepCCauseId: 523,
    hepatitisCauseId: 2900,
    nonHepatitisCauseIds: '297,298,345',
    hepatitisBCauseId: 2901,
    hepatitisCCauseId: 2902,
    hepCWithoutCirrhosis: 902,
    hepBWithoutCirrhosis: 903,

    factsheetBreakdownCauses: [401, 402, 522, 418, 403, 523, 419, 404],
    factsheetPrevalenceIncidenceCauses: [401, 402, 522, 418, 18673, 403, 523, 419, 2994, 404],
} as const;

const derivedConstants = {
    locationGroupIds: [
        idConstants.globalLocationId,
        idConstants.highMiddleSdiLocationId,
        idConstants.highSdiLocationId,
        idConstants.lowMiddleSdiLocationId,
        idConstants.lowSdiLocationId,
        idConstants.middleSdiLocationId,
    ],

    defaultAgeGroupId: idConstants.allAgesGroupId,
    defaultGenderId: idConstants.bothGendersId,
    defaultMeasureId: idConstants.yllMeasureId,
    defaultSequelaMeasureId: idConstants.prevalenceMeasureId,
    defaultCauseId: 400,
    defaultLocationId: idConstants.USALocationId,
    latestYear: 2017,

    breakdownDefaultAgeGroupId: idConstants.allAgesGroupId,
    breakdownDefaultLocationIds: [idConstants.USALocationId],
    breakdownDefaultMetricId: idConstants.rateMetricId,
    breakdownCauses: [401, 402, 403, 404, 418, 419, 522, 523],

    trendsGenders: [idConstants.maleAndFemaleGenderId, idConstants.bothGendersId],
    trendsDefaultGenderId: idConstants.maleAndFemaleGenderId,
    trendsDefaultCauseId: idConstants.hepatitisCauseId,
    trendsExtraCauses: [
        idConstants.hepatitisCauseId,
        idConstants.hepatitisBCauseId,
        idConstants.hepatitisCCauseId,
    ],

    globalImpactDefaultMetricId: idConstants.rateMetricId,
    globalImpactDefaultAgeGroupId: idConstants.allAgesGroupId,
    globalImpactDefaultMeasureId: idConstants.deathMeasureId,
    globalImpactDefaultGenderId: idConstants.bothGendersId,
    globalImpactDefaultCauseId: idConstants.hepatitisCauseId,
} as const;

export default {
    ...idConstants,
    ...derivedConstants,
    apiUrl: runtimeConfig.apiUrl,
    appName: 'IHME Hepatitis Facts',
    storageVersion: '0.0.27',
    storageCacheVersion: '2',
    googleAnalyticsId: 'G-9Q1NRDER3T',
    googleAnalyticsDebug: false,
};
